import axios from 'axios'
import { TRUST_AUTH_TOKENS_KEY } from '../constants/storage'

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL ?? 'https://api.trustinsight.com.br',
})

function setAccessToken() {
  const authTokens = localStorage.getItem(TRUST_AUTH_TOKENS_KEY)

  if (authTokens) {
    const { accessToken } = JSON.parse(authTokens)

    api.defaults.headers.common.Authorization = `Bearer ${accessToken}`
  }
}

setAccessToken()

let isRefreshing = false
let failedRequestsQueue: any[] = []

api.interceptors.response.use(
  (response: any) => response,
  async (error: {
    response: { status: number; data: { message: string } }
    config: any
  }) => {
    if (error.response.status === 401) {
      if (error.response.data.message === 'Expired JWT token') {
        const tokens = localStorage.getItem(TRUST_AUTH_TOKENS_KEY)

        if (tokens) {
          const parsedTokens = JSON.parse(tokens)
          const originalConfig = error.config

          if (!isRefreshing) {
            isRefreshing = true

            api
              .post('/auth/refresh-token', {
                refreshToken: parsedTokens.refreshToken,
              })
              .then(({ data }) => {
                const { accessToken, refreshToken } = data

                localStorage.setItem(
                  TRUST_AUTH_TOKENS_KEY,
                  JSON.stringify({
                    accessToken,
                    refreshToken,
                  })
                )

                api.defaults.headers.common.Authorization = `Bearer ${accessToken}`

                failedRequestsQueue.forEach((request) => {
                  request.onSuccess(accessToken)
                })

                failedRequestsQueue = []
              })
              .catch((error: any) => {
                failedRequestsQueue.forEach((request) =>
                  request.onFailure(error)
                )
                failedRequestsQueue = []
              })
              .finally(() => {
                isRefreshing = false
              })
          }

          return new Promise((resolve, reject) => {
            failedRequestsQueue.push({
              onSuccess(token: string) {
                originalConfig.headers.Authorization = `Bearer ${token}`
                resolve(api(originalConfig))
              },
              onFailure(error: unknown) {
                reject(error)
              },
            })
          })
        }
      }
    }

    return Promise.reject(error)
  }
)
